import React from 'react';
import SectionHeader from './SectionHeader';

const About = () => {
  return (
    <section
      id="about"
      className="content-section !mb-6 md:!mb-8 lg:!mb-10 sticky-section"
      aria-label="About me"
    >
      <SectionHeader id="about" title="About" />

      <div>
        <p>
          I'm a{' '}
          <strong className="font-semibold text-lightest-slate">
            strategic, hands-on growth leader
          </strong>{' '}
          for consumer software companies. Outside work, I'm raising two young
          kids and building a collection of jazz biographies.
        </p>
      </div>
    </section>
  );
};

export default About;
